import { BuilderConfig } from '@/types/builder';

import RoomStayBlogCustomerListCard3, { CustomerCaseListCard3Props } from './roomstay-blog-customer-case-list-card-3';

export const RoomStayBlogCustomerCaseListCard3BuilderConfig = {
    name: 'Customer Case List Card 3',
    inputs: [
        {
            name: 'tag',
            type: 'string',
            defaultValue: '',
        },
        {
            name: 'title',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'ctaButton',
            type: 'object',
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    defaultValue: '',
                },
                {
                    name: 'href',
                    type: 'string',
                    defaultValue: '',
                },
            ],
        },
        {
            name: 'cards',
            type: 'list',
            subFields: [
                {
                    name: 'icon',
                    type: 'file',
                },
                {
                    name: 'contentData',
                    type: 'richText',
                    defaultValue: '',
                },
                {
                    name: 'title',
                    type: 'richText',
                    defaultValue: '',
                },
                {
                    name: 'description',
                    type: 'richText',
                    defaultValue: '',
                },
                {
                    name: 'background',
                    type: 'color',
                    defaultValue: '',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<CustomerCaseListCard3Props> = {
    component: RoomStayBlogCustomerListCard3,
    config: RoomStayBlogCustomerCaseListCard3BuilderConfig,
};

export default builderConfig;
